import { Injectable } from '@angular/core';

@Injectable()
export class SettingsProvider {

  DEAL_OPEN = 1
  DEAL_WON = 2
  DEAL_LOST = 3

  MEETING_PLANNED = 1
  MEETING_DONE = 2
  MEETING_CANCEL = 3
  MEETING_LEAVED = 4

  PIPELINE_VENDITA: number
  PIPELINE_VISTE_FREDDE: number

  STAGE_PROBLEM_UNAWARE: number
  STAGE_APPOINTMENT_TODO: number
  STAGE_APPOINTMENT_DONE: number
  STAGE_APPOINTMENT_UNDONE: number


  PIPELINE_VENDITA_SOCIAL: number
  STAGE_APPOINTMENT_TODO_SOCIAL: number
  STAGE_APPOINTMENT_DONE_SOCIAL: number
  STAGE_APPOINTMENT_UNDONE_SOCIAL: number


  PIPELINE_VENDITA_BY_PRODUCT: {
    "myP": number,
    "Social": number
  }
  STAGE_APPOINTMENT_TODO_BY_PRODUCT: {
    "myP": number,
    "Social": number
  }
  STAGE_APPOINTMENT_DONE_BY_PRODUCT: {
    "myP": number,
    "Social": number
  }
  STAGE_APPOINTMENT_UNDONE_BY_PRODUCT: {
    "myP": number,
    "Social": number
  }

  PRODUCT_MYP_ID: number
  PRODUCT_MYP: string
  LIST_ID: number

  PRODUCT_SOCIAL: string
  PRODUCT_SOCIAL_ID: number

  PRODUCTS: String[]

  SOURCE_DEFAULT: number

  production = {

    PIPELINE_VENDITA: 4,
    PIPELINE_VISTE_FREDDE: 6,

    STAGE_PROBLEM_UNAWARE: 24,
    STAGE_APPOINTMENT_TODO: 16,
    STAGE_APPOINTMENT_DONE: 17,
    STAGE_APPOINTMENT_UNDONE: 18,


    PIPELINE_VENDITA_SOCIAL: 20,
    STAGE_APPOINTMENT_TODO_SOCIAL: 127,
    STAGE_APPOINTMENT_DONE_SOCIAL: 126,
    STAGE_APPOINTMENT_UNDONE_SOCIAL: 128,

    PIPELINE_VENDITA_BY_PRODUCT: {
      "myP": 4,
      "Social": 20
    },
    STAGE_APPOINTMENT_TODO_BY_PRODUCT: {
      "myP": 16,
      "Social": 127
    },
    STAGE_APPOINTMENT_DONE_BY_PRODUCT: {
      "myP": 17,
      "Social": 126
    },
    STAGE_APPOINTMENT_UNDONE_BY_PRODUCT: {
      "myP": 18,
      "Social": 128
    },

    PRODUCT_MYP_ID: 2,
    PRODUCT_MYP: "myP",
    PRODUCT_SOCIAL: "Social",
    PRODUCT_SOCIAL_ID: 10,
    LIST_ID: 23,
    PRODUCTS: ["myP", "Social"],
    SOURCE_DEFAULT: 2,

  }

  staging = {

    PIPELINE_VENDITA: 11,
    PIPELINE_VISTE_FREDDE: 13,

    STAGE_PROBLEM_UNAWARE: 55,
    STAGE_APPOINTMENT_TODO: 43,
    STAGE_APPOINTMENT_DONE: 44,
    STAGE_APPOINTMENT_UNDONE: 45,


    PIPELINE_VENDITA_SOCIAL: 19,
    STAGE_APPOINTMENT_TODO_SOCIAL: 97,
    STAGE_APPOINTMENT_DONE_SOCIAL: 98,
    STAGE_APPOINTMENT_UNDONE_SOCIAL: 99,

    PIPELINE_VENDITA_BY_PRODUCT: {
      "myP": 11,
      "Social": 19
    },
    STAGE_APPOINTMENT_TODO_BY_PRODUCT: {
      "myP": 43,
      "Social": 97
    },
    STAGE_APPOINTMENT_DONE_BY_PRODUCT: {
      "myP": 44,
      "Social": 98
    },
    STAGE_APPOINTMENT_UNDONE_BY_PRODUCT: {
      "myP": 45,
      "Social": 99
    },

    PRODUCT_MYP_ID: 5,
    PRODUCT_MYP: "myP",
    PRODUCT_SOCIAL: "Social",
    PRODUCT_SOCIAL_ID: 12,
    LIST_ID: 23,

    PRODUCTS: ["myP", "Social"],

    SOURCE_DEFAULT: 2,

  }

  private enviroment = this.production
  constructor() {
    Object.assign(this, this.enviroment)
  }

}



// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts